import { api } from '../plugins/axios_settings'

const state = {
  project: {}
}

const mutations = {
  setProject (state, project) {
    state.project = project
  }
}

const actions = {
  async getProject ({ commit }, projectId) {
    try {
      const response = await api.get(`projects/${projectId}`)
      commit('setProject', response.data)
    } catch (error) {
      this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: error.response?.data?.message || 'Error fetching project data' })
    }
  }
}

const getters = {
  project: state => state.project
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
